import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import { CustomSpinner } from '~/commonComponents';
import { useGetDraftJobPost, useSaveDraftJobPost } from '~/domain/PermanentJobs';
import { showErrorMessage } from '~/domain/utils';
import { JobDetailsForm, JobDetailsFormMapper, type IJobDetailsForm } from '../JobDetailsForm';
import { useAppSelector } from '~/hooks';

export const JobPostingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const { data: draftData, isLoading, isError, error } = useGetDraftJobPost(id);
  const { mutate: saveDraft } = useSaveDraftJobPost();

  const isEditMode = location.state?.editMode || false;
  const scrollToSection = location.state?.scrollToSection;

  const totalWorkingInterviewsCount = useAppSelector((state) => {
    if (!id) return 0;
    return state.permanentJobs.workingInterviews[id]?.length ?? 0;
  });

  useEffect(() => {
    if (isError) {
      showErrorMessage({ error });
    }
  }, [isError, error, dispatch]);

  const handleNext = (formData: IJobDetailsForm) => {
    if (!id) return;

    const payload = JobDetailsFormMapper.toSaveDraftPayload(formData);
    saveDraft(
      { id, payload },
      {
        onSuccess: () => {
          if (isEditMode && totalWorkingInterviewsCount) {
            navigate(-1);
            return;
          }

          navigate(`/permanent-jobs/postings/${id}/working-interviews`);
        },
        onError: (err) => {
          showErrorMessage({ error: err });
        },
      },
    );
  };

  if (isLoading) {
    return <CustomSpinner isLoading />;
  }

  return (
    <JobDetailsForm
      submitButtonText="Next"
      onSubmit={handleNext}
      initialValues={draftData}
      editMode={isEditMode}
      scrollToSection={scrollToSection}
    />
  );
};
